/**
 * SupersededAnalysisNote — read-only stamp when figures were overlaid from a
 * newer War Room run than the cached analysis narrative.
 */
import React from 'react';
import { AlertTriangle } from 'lucide-react';

export interface CurrencyInfo {
  superseded?: boolean;
  current_run_id?: string | null;
  current_run_at?: string | null;
  analysis_at?: string | null;
}

interface SupersededAnalysisNoteProps {
  currency?: CurrencyInfo | null;
  className?: string;
}

export function SupersededAnalysisNote({
  currency,
  className = '',
}: SupersededAnalysisNoteProps) {
  if (!currency?.superseded) return null;

  const runId = currency.current_run_id;

  return (
    <div
      className={`flex items-start gap-2 rounded-lg border border-[var(--color-border)] bg-[var(--color-bg-elevated)] p-3 ${className}`}
      data-testid="superseded-analysis-note"
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 flex-shrink-0 text-[var(--color-needs-human-text)]" />
      <p className="text-xs leading-relaxed text-[var(--color-text-secondary)]">
        Figures updated to latest War Room run
        {runId ? (
          <span className="font-mono text-[var(--color-text-muted)]"> {runId}</span>
        ) : null}
        . Narrative predates it; re-run analysis to refresh.
      </p>
    </div>
  );
}

export default SupersededAnalysisNote;
